<template>
  <div class="BarcodeControl">
    <div :style="{ margin: boxMargin }">
      <div class="w-full h-full">
        <span class="desc align-center">
          <AFitText>출고처-{{data.customer_name}}
          수주번호 {{data.contract_code}}</AFitText>
        </span>
        <div class="barcode">
          <div class="of-hidden align-center">
            <VueBarcode 
            v-bind:value="data.contract_code" 
            height="44" 
            margin="0" 
            :width="3.4"
            :displayValue="false"
            />
          </div>
          <div class="model-code">
            {{ data.code }}
          </div>
        </div>      
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
import AFitText from '@/shared/AFitText';

export default {
  name: "BarcodeControl",
  components: {VueBarcode, AFitText},
  data() {
    return {}
  },
  props: {
    config: {
      type: Object,
      default: function() {
        return {
          margin_left: 0,
          margin_top: 0,
        }
      }
    },
    data: {
      type: Object,
      default: function() { 
        return {
          customer_name: '',
        }; 
      }
    },
  },  
  computed: {
    boxMargin() {
      let margin_top = this.config.margin_top ? this.config.margin_top + "px" : 0;
      let margin_left = this.config.margin_left ? this.config.margin_left + "px" : 0;
      return "" + margin_top + " 0 0 " + margin_left;
    },
  },
}
</script>
<style lang="scss" scoped>
.BarcodeControl {
  width: 370px;
  height: 100px;
  padding: 5px 10px 5px 5px;
  margin: 0;
  
  .desc {
    font-size: 12pt;
    display: block;
    margin-top: 3pt;
    margin-bottom: 3pt;
  }
  .barcode {
    height: 60px;
    >div {
      padding-left: 10px;
    }
  }
}
</style>
<style type="text/css" media="print"> 
.BarcodeControl {
  size:70mm 20mm; margin: 0;
  font-family: "돋움";
  page-break-after: always;
} 
.model-code{
    text-align: center;    
    font-size: 14px;
    font-weight: 700;
    color: #000;
    margin-bottom: 3px;
}
</style>